import { apiRequest } from "../apiRequest";

export const verifyDebit = (data) =>
    apiRequest(`/payment/verify/${data?.ref}`, "POST", data);
